module.exports = __webpack_public_path__ + "img/logo20.ef00474c.png";